import React, { Dispatch, SetStateAction } from 'react';
import { useDispatch } from 'react-redux';
import ConfirmModal from '@components/modal/ConfirmModal';
import { postMarkChallengeAsReadyForAssessment } from '@actions/challenges';
import { Challenge } from 'src/types/shared/Challenge';

const MarkToBeAssessedModal: React.FC<MarkToBeAssessedModalProps> = ({
    challenge,
    setShowMarkToBeAssessedModal,
    groupId,
}) => {
    const dispatch = useDispatch();

    return (
        <ConfirmModal
            title="Ready to be assessed"
            description={`Are you sure you want to mark '${challenge.name}' as ready to be assessed?`}
            closeModal={() => setShowMarkToBeAssessedModal(false)}
            handleSubmit={() => {
                dispatch(postMarkChallengeAsReadyForAssessment(challenge.id));
                setShowMarkToBeAssessedModal(false);
            }}
        />
    );
};

interface MarkToBeAssessedModalProps {
    challenge: Challenge;
    setShowMarkToBeAssessedModal: Dispatch<SetStateAction<boolean>>;
    groupId: string;
}

export default MarkToBeAssessedModal;
